// Credential Management API helpers for silent auto-login.
// Falls back gracefully on unsupported browsers (Safari, Firefox).

declare class PasswordCredential extends Credential {
  constructor(data: { id: string; password: string })
  readonly password: string
}

export async function storeCredentials(
  email: string,
  password: string,
): Promise<void> {
  if (!('PasswordCredential' in window)) return
  try {
    const cred = new PasswordCredential({ id: email, password })
    await navigator.credentials.store(cred)
  } catch {
    // Best-effort — silently ignore storage failures
  }
}

export async function getSilentCredentials(): Promise<{
  id: string
  password: string
} | null> {
  if (!('PasswordCredential' in window)) return null
  try {
    const cred = (await navigator.credentials.get({
      password: true,
      mediation: 'silent',
    } as CredentialRequestOptions)) as PasswordCredential | null
    if (cred?.id && cred?.password) {
      return { id: cred.id, password: cred.password }
    }
    return null
  } catch {
    return null
  }
}

export async function clearSilentAccess(): Promise<void> {
  if (!navigator.credentials?.preventSilentAccess) return
  try {
    await navigator.credentials.preventSilentAccess()
  } catch {
    // Best-effort
  }
}
